export default class ValidationPassword {
    static validate(string) {
        const length = string.length;
        const rules = {
            contains_chars: /[a-zA-Z]/.test(string),
            contains_number: /\d/.test(string),
            validLength: length > 5,
            password_valid: false
        };
        if (rules.contains_chars && rules.contains_number && rules.validLength) {
            rules.password_valid = true;
        }
        return rules;
    }
}
